import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/modules/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgDragDropModule } from 'ng-drag-drop';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../pipes/pipes.module';

import { DepartmentSheetEdit } from "./components/departmentSheet-edit/departmentSheet-edit.component";
import { DepartmentSheetTable } from "./components/departmentSheet-table/departmentSheet-table.component";
import { EnrichDiscrepanciesTable } from "./components/enrich-discrepancies-table/enrich-discrepancies-table.component";
import { EnrichEditForm } from "./components/enrich-edit-form/enrich-edit-form.component";
import { EnrichTable } from "./components/enrich-table/enrich-table.component";
import { FollowIdComponent } from "./components/followId-confirmation/followId-confirmation.component";
import { ObservationModal } from "./components/observation-modal/observation-modal.component";
import { PackagingTable } from "./components/packaging-table/packaging-table.component";
import { UploadDiscrepanciesModal } from "./components/upload-discrepancies-modal/upload-discrepancies-modal.component";
import { SupplierPortalHome } from "./containers/supplier-portal-home/supplier-portal-home.component";
import { SupplierPortalPage } from "./containers/supplier-portal-page/supplier-portal-page.component";
import { SupplierPortalRoutingModule } from "./supplier-portal-routing.module";

@NgModule({
    imports: [
    CommonModule,
    NgbModule,
    SupplierPortalRoutingModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgDragDropModule,
    NgxPaginationModule
  ],
  declarations: [
    SupplierPortalPage,
    EnrichTable,
    EnrichEditForm,
    DepartmentSheetTable,
    DepartmentSheetEdit,
    SupplierPortalHome,
    EnrichDiscrepanciesTable,
    PackagingTable,
    FollowIdComponent,
    UploadDiscrepanciesModal,
    ObservationModal
  ],
  entryComponents: [
    EnrichEditForm,
    UploadDiscrepanciesModal,
    ObservationModal
  ]
})
export class SupplierPortalModule {}